import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import TLDepartment from "@/pages/TLDepartment";
import SwatchesDepartment from "@/pages/SwatchesDepartment";
import GarmentDepartment from "@/pages/GarmentDepartment";
import BackupStatus from "@/pages/BackupStatus";
import { Toaster } from "sonner";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" richColors />
        <PWAInstallPrompt />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tl"
              element={
                <ProtectedRoute>
                  <TLDepartment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/swatches"
              element={
                <ProtectedRoute>
                  <SwatchesDepartment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/garments"
              element={
                <ProtectedRoute>
                  <GarmentDepartment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/backup"
              element={
                <ProtectedRoute>
                  <BackupStatus />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
